import { request } from './apiClient'

const qs = (params = {}) => {
  const q = new URLSearchParams(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  ).toString()
  return q ? `?${q}` : ''
}

export const fetchTickets = (params) => request('GET', `/v1/tickets/${qs(params)}`)
export const fetchTicket = (id) => request('GET', `/v1/tickets/${id}/`)
export const createTicket = (data) => request('POST', '/v1/tickets/', data)
export const updateTicket = (id, data) => request('PATCH', `/v1/tickets/${id}/`, data)
export const addTicketComment = (id, body, isInternal = false) =>
  request('POST', `/v1/tickets/${id}/comments/`, { body, is_internal: isInternal })
export const addTicketLink = (id, type, objectId) =>
  request('POST', `/v1/tickets/${id}/links/`, { type, id: objectId })
export const removeTicketLink = (id, linkId) =>
  request('DELETE', `/v1/tickets/${id}/links/${linkId}/`)
export const fetchLinkTargets = (type, q) =>
  request('GET', `/v1/tickets/link_targets/${qs({ type, q })}`)
export const fetchTicketCounts = () => request('GET', '/v1/tickets/counts/')
